import { notification } from '@edulastic/common'
import API from './utils/API'

const prefix = '/admin-tool'

const api = new API()

const showErrorNotification = (error) => {
  const message = error?.response?.data?.message || 'Something went wrong'
  notification({ type: 'error', msg: message })
}

const withOrgScope = ({ districtId, districtGroupId, ...rest }) => {
  const payload = { ...rest }
  if (districtId) payload.districtId = districtId
  if (districtGroupId) payload.districtGroupId = districtGroupId
  return payload
}

const getDistinctFeedTypes = () =>
  api
    .callApi({
      url: `${prefix}/distinct-feed-types`,
      method: 'get',
    })
    .then(({ data: response }) => response)
    .catch((error) => showErrorNotification(error))

const deleteFeedType = (data) =>
  api
    .callApi({
      useSlowApi: true,
      url: `${prefix}/delete-feed-type`,
      method: 'delete',
      data: withOrgScope(data),
    })
    .then(() =>
      notification({ type: 'success', messageKey: 'deleteFeedTypeSuccess' })
    )
    .catch((error) => showErrorNotification(error))

const insertFeedType = (data) =>
  api
    .callApi({
      useSlowApi: true,
      url: `${prefix}/insert-feed-types`,
      method: 'post',
      data: withOrgScope(data),
    })
    .then(() =>
      notification({ type: 'success', messageKey: 'insertFeedTypesSucess' })
    )
    .catch((error) => showErrorNotification(error))

const updateFeedType = (data) =>
  api
    .callApi({
      useSlowApi: true,
      url: `${prefix}/update-feed-types`,
      method: 'put',
      data: withOrgScope(data),
    })
    .then(() =>
      notification({
        type: 'success',
        messageKey: 'updateFeedTypesSuccess',
        duration: 12,
      })
    )
    .catch((error) => showErrorNotification(error))

const updateCurriculum = ({ curriculumId, data }) =>
  api
    .callApi({
      url: `${prefix}/curriculum/${curriculumId}`,
      method: 'put',
      data,
    })
    .then((result) => result.data.result)

export default {
  getDistinctFeedTypes,
  deleteFeedType,
  insertFeedType,
  updateFeedType,
  updateCurriculum,
}
